import {Col, Row} from "antd";
import {
    ShiftReportStatusFilter,
    SubCompanyFilter
} from "components/_defaultComponents/FilterComponents";
import {DatePickerButtons} from "components/_defaultComponents/FilterComponents";
import ShiftScoreTable from "components/shiftScore/Components/ShiftScoreTable";
import {useStore} from "hooks/useStore";
import React, {useState} from "react";
import {
    CustomTab,
    TabRow,
    FilterTab,
    FilterTabsContainer,
    FilterTabContent,
    FiltersContainer,
    PastShiftsFilters,
    SubcompanyFilterContainer,
    RightFiltersContainer,
    LeftFiltersContainer
} from "../CustomerHomePageWithShiftScore.styles";
import {
    CheckCircleOutlined,
    CloseCircleOutlined,
    InboxOutlined,
    UnorderedListOutlined
} from "@ant-design/icons";

const PastShifts = ({
    pastShiftsFilters,
    setPastShiftsFilters,
    hasMultipleSubcompanies,
    currentPage,
    setCurrentPage,
    reloadData,
    setReloadData,
    reloadCount,
    setReloadCount,
    onSubCompanyChange,
    pastLoading,
    pastData,
    setPastData
}) => {
    const stores = useStore();
    const [isPastShifts, setIsPastShifts] = useState(true);

    const handleFilterChange = (newFilters, period) => {
        setPastShiftsFilters(newFilters);
        if (period !== "today") {
            setPastShiftsFilters(prev => ({
                ...prev,
                currentStatus: "all"
            }));
        }
    };

    return (
        <>
            <PastShiftsFilters hasMultipleSubcompanies={hasMultipleSubcompanies}>
                <LeftFiltersContainer>
                    {hasMultipleSubcompanies && (
                        <SubcompanyFilterContainer>
                            <SubCompanyFilter
                                defaultValue={pastShiftsFilters.subCompany}
                                value={pastShiftsFilters.subCompany}
                                onChange={onSubCompanyChange}
                                company={stores?.meStore?.companies?.[0]?._id}
                                mode="multiple"
                                showAllOption={true}
                                allowClear={true}
                                disabled={false}
                                initialCall={true}
                            />
                        </SubcompanyFilterContainer>
                    )}
                    <DatePickerButtons
                        filters={pastShiftsFilters}
                        setFilters={setPastShiftsFilters}
                        type="past"
                        onFilterChange={handleFilterChange}
                    />
                </LeftFiltersContainer>
                <RightFiltersContainer>
                    <div>
                        <FilterTabsContainer>
                            <FilterTab
                                isActive={pastShiftsFilters.status === "all"}
                                onClick={() =>
                                    setPastShiftsFilters(prev => ({...prev, status: "all"}))
                                }
                            >
                                <FilterTabContent>
                                    <UnorderedListOutlined style={{fontSize: "14px"}} />
                                    <span style={{fontSize: "14px", whiteSpace: "nowrap"}}>
                                        Tümü
                                    </span>
                                </FilterTabContent>
                            </FilterTab>
                            <FilterTab
                                isActive={pastShiftsFilters.status === "approved"}
                                onClick={() =>
                                    setPastShiftsFilters(prev => ({...prev, status: "approved"}))
                                }
                            >
                                <FilterTabContent>
                                    <CheckCircleOutlined style={{fontSize: "14px"}} />
                                    <span style={{fontSize: "14px", whiteSpace: "nowrap"}}>
                                        Onaylanan
                                    </span>
                                </FilterTabContent>
                            </FilterTab>
                            <FilterTab
                                isActive={pastShiftsFilters.status === "inReview"}
                                onClick={() =>
                                    setPastShiftsFilters(prev => ({...prev, status: "inReview"}))
                                }
                                iconBgColor="#cf1322"
                                iconColor="white"
                            >
                                <FilterTabContent>
                                    <CloseCircleOutlined style={{fontSize: "14px"}} />
                                    <span style={{fontSize: "14px", whiteSpace: "nowrap"}}>
                                        Askıya Alınan
                                    </span>
                                </FilterTabContent>
                            </FilterTab>
                            <FilterTab
                                isActive={pastShiftsFilters.status === "needFillPackage"}
                                onClick={() =>
                                    setPastShiftsFilters(prev => ({
                                        ...prev,
                                        status: "needFillPackage"
                                    }))
                                }
                                iconBgColor="#fa8c16"
                                iconColor="white"
                            >
                                <FilterTabContent>
                                    <InboxOutlined style={{fontSize: "14px"}} />
                                    <span style={{fontSize: "14px", whiteSpace: "nowrap"}}>
                                        Paket Bekleyen
                                    </span>
                                </FilterTabContent>
                            </FilterTab>
                        </FilterTabsContainer>
                    </div>
                </RightFiltersContainer>
            </PastShiftsFilters>
            <ShiftScoreTable
                loading={pastLoading}
                data={pastData?.rows || []}
                setData={setPastData}
                dataCount={pastData?.dataCount}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                setReloadData={() => setReloadData(!reloadData)}
                setReloadCount={() => setReloadCount(!reloadCount)}
                filters={pastShiftsFilters}
                isPastShifts={isPastShifts}
            />
        </>
    );
};

export default PastShifts;
